/* eslint-disable */
import { analyticsConstants } from '@/Constants';
import analyticsServices from '@/Services/analytics.services';

const wastageAction = {
	wastageList,
	transitList,
	qualityList,
	aiQualityList,
	grnList,
	notificationList,
	transitLossList,
	faliureRequest,
	loading,
	fetchTransitLossList,
	isSuccess,
	saveTransitLossRecoverdQty,
};

function wastageList(payload) {
	return {
		type: analyticsConstants.SET_WASTAGE,
		payload,
	};
}

function transitList(payload) {
	return {
		type: analyticsConstants.SET_TRANSIT,
		payload,
	};
}
function qualityList(payload) {
	return {
		type: analyticsConstants.SET_QUALITY,
		payload,
	};
}
function aiQualityList(payload) {
	return {
		type: analyticsConstants.SET_QUALITY_AI,
		payload,
	};
}
function grnList(payload) {
	return {
		type: analyticsConstants.SET_GRN,
		payload,
	};
}
function notificationList(payload) {
	return {
		type: analyticsConstants?.SET_NOTIFICATION,
		payload,
	};
}
function transitLossList(payload) {
	return {
		type: analyticsConstants?.SET_TRANSIT_LOSS,
		payload,
	};
}
function setSingleTransitLoss(payload) {
	return {
		type: analyticsConstants?.SET_SINGLE_TRANSIT_LOSS,
		payload,
	};
}
function faliureRequest(payload) {
	return {
		type: analyticsConstants?.SET_FAILURE_REQUEST,
		payload,
	};
}
function loading(payload) {
	return {
		type: analyticsConstants?.SET_LOADING_REQUEST,
		payload,
	};
}

function isSuccess(payload) {
	return {
		type: analyticsConstants?.SET_SUCCESS,
		payload,
	};
}

function fetchTransitLossList(payload, singleFetch = false) {
	return async (dispatch) => {
		try {
			dispatch(loading(true));
			const response = await analyticsServices.fetchTransitLossList(payload);
			if (response?.statusCode === 200) {
				if (singleFetch) {
					dispatch(setSingleTransitLoss(response?.data));
				} else {
					dispatch(transitLossList(response?.data));
				}
			}
		}
		catch (error) {
			dispatch(faliureRequest(error));
		}
		finally {
			dispatch(loading(false));
		}
	}
}

function saveTransitLossRecoverdQty(payload) {
	return async (dispatch) => {
		try {
			dispatch(loading(true));
			const response = await analyticsServices.saveTransitLossRecoverdQty(payload);
			if (response?.statusCode === 200) {
				dispatch(isSuccess('Transit Loss Recovered Qty Saved Successfully'));
			}
		}
		catch (error) {
			dispatch(faliureRequest(error));
		}
		finally {
			dispatch(loading(false));
		}
	}
}


export default wastageAction;
